<template>
	<base-data-table
		:service-provider="serviceProvider"
		:vuex-module="vuexModule"
		:header-columns="headerColumns"
		:query-params="queryParams"
		label="Reports"
	>
		<template v-slot:header-left="{ selected }">
			<b-button
				v-if="selected.length"
				@click.prevent="
					assignToAllMembers(
						selected.map((item) => item.report_id),
						companySvc.company.id
					)
				"
				:disabled="isAssigningToAll"
				variant="link"
				size="sm"
				class="text-info bg-transparent py-1 px-0 mr-3 font-weight-normal d-flex align-items-center shadow-none"
			>
				<b-icon
					v-if="isAssigningToAll"
					icon="circle-fill"
					animation="throb"
					font-scale="0.85"
					class="mr-1"
				></b-icon
				>{{ isAssigningToAll ? "Assigning" : "Assign" }} to All
				Members</b-button
			>
		</template>
		<template #header-right>
			<div class="navbar-search form-inline ml-auto mr-3">
				<b-form-group class="mb-0">
					<b-input-group
						class="input-group-alternative input-group-merge"
					>
						<div class="input-group-prepend">
							<span class="input-group-text"
								><i class="fas fa-search"></i
							></span>
						</div>
						<b-form-input
							@input="onSearch"
							placeholder="Search"
							size="sm"
							type="text"
						>
						</b-form-input>
					</b-input-group>
				</b-form-group>
			</div>

			<base-button
				@click.stop="
					$bus.$emit('toggle-modal', {
						key: 'company-report-access',
						active: true,
					})
				"
				type="primary"
				size="sm"
				class="px-4"
				outline
				>Add Report</base-button
			>
		</template>

		<template v-slot:cell_name_OR_report="{ row }">
			{{ row.name }}
			<strong
				v-if="row.report_id == companySvc.company.default_report_id"
			>
				( Default )
			</strong>
		</template>
		<template v-slot:cell_report="{ value }">{{ value.name }}</template>
	</base-data-table>
</template>

<script>
import { debounce } from "lodash-es";

import { companyReportsTableData } from "@datas";
import { reportMixin, userMixin } from "@mixins";
import BaseDataTable from "@components/BaseDataTable";

export default {
	name: "table-company-reports",
	components: {
		BaseDataTable,
	},
	inject: ["companySvc", "reportSvc"],
	mixins: [reportMixin, userMixin],
	data() {
		return {
			...companyReportsTableData,
			isAssigningToAll: false,
		};
	},
	methods: {
		onSearch: debounce(function (keyword) {
			this.$bus.$emit("datatable-search", keyword);
		}),
	},
	created() {
		this.serviceProvider = this.reportSvc;
		this.queryParams.company_id = this.companySvc.company.id;
	},
	mounted() {
		this.$bus.trackEvent("datatable-cell-click", (row) => {
			const encodedID = this.encodeReportID(row.report_id, this.isUserRole("Superuser") ? this.$route.params.id : null)

			this.$router.push({
				name: "ReportView",
				params: { id: encodedID },
			});
		});

		// Check if deleted item is the company's default report
		this.$bus.trackEvent("datatable-item-deleted", async (payload) => {
			if (
				!payload.report_id ||
				payload.report_id != this.companySvc.company.default_report_id
			)
				return false;

			if (0 < this.reportSvc.reports.count) {
				const newDefaultReport = this.reportSvc.reports.results[0];

				await this.companySvc.update(
					{
						...this.companySvc.company,
						default_report_id: newDefaultReport.report_id,
					},
					false
				);

				this.$toasted.show(
					`New company default report updated to "${newDefaultReport.name}"`
				);

				this.$store.commit("UPDATE_COMPANY_DATA", {
					key: "default_report_id",
					value: newDefaultReport.report_id,
				});
			}
		});

		this.$emitter.on("assign-report-access", (payload) => {
			if (
				payload &&
				payload.status &&
				"all-members" === payload.assignee
			) {
				this.isAssigningToAll = true;
			} else {
				this.isAssigningToAll = false;

				this.$bus.$emit("datatable-unselect-rows");

				this.$toasted.show("Report assigned successfully");
			}
		});
	},
	beforeDestroy() {
		this.$bus.destroyEvents();
	},
};
</script>
